<template>
  <el-dialog
    :visible="show"
    :title="title"
    :width="width"
    :append-to-body="appendToBody"
    :close-on-click-modal="closeOnClickModal"
    @close="$emit('close')"
    @update:visible="$emit('update:show', $event)"
  >
    <slot />
    <span v-if="$slots.footer" slot="footer" class="dialog-footer">
      <slot name="footer" />
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'EcModal',
  props: {
    show: { type: Boolean, default: false },
    title: { type: String, default: '' },
    width: { type: String, default: '500px' },
    appendToBody: { type: Boolean, default: true },
    closeOnClickModal: { type: Boolean, default: true },
  },
}
</script>
